import { supabase } from '@/lib/supabase';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

export interface TagDeleteMutation {
	id: string;
	role: string;
}

export interface TagMutation {
	color: string;
	name: string;
	definition: string;
	role: string;
	discipline: string;
}

export interface EditTagMutation extends TagMutation {
	id: string;
}

export const deleteTagFrag = async (variables: TagDeleteMutation) => {
	const { id } = variables;

	const { error } = await supabase.from('tags').delete().eq('tag_id', id).eq('school_id', schoolId);

	if (error) throw error;

	return { affected_rows: 1 };
};

export const addNewTagFrag = async (variables: TagMutation) => {
	const { color, name, definition, discipline } = variables;

	const { error } = await supabase.from('tags').insert({
		tag_color: color,
		tag_name: name,
		tag_definition: definition || null,
		tag_discipline: discipline || null,
		school_id: schoolId,
	});

	if (error) throw error;

	return { affected_rows: 1 };
};

export const editTagFrag = async (variables: EditTagMutation) => {
	const { id, color, name, definition, discipline } = variables;

	const { error } = await supabase
		.from('tags')
		.update({
			tag_color: color,
			tag_name: name,
			tag_definition: definition || null,
			tag_discipline: discipline || null,
		})
		.eq('tag_id', id)
		.eq('school_id', schoolId);

	if (error) throw error;

	return { affected_rows: 1 };
};
